export default {
  'apiCallResponseStatusCodeActionMapping.title': 'Response Code / Next Action Mappings',

  'apiCallResponseStatusCodeActionMapping.form.responseHttpStatusCode': 'Http Status Code',
  'apiCallResponseStatusCodeActionMapping.form.nextAction': 'Next Action',

  'apiCallResponseStatusCodeActionMapping.mapping': 'Mapping',
  'apiCallResponseStatusCodeActionMapping.addMapping': 'Add mapping',
  'apiCallResponseStatusCodeActionMapping.noMappings': 'No mappings configured.',
};
